export default __webpack_public_path__ + "static/media/Y18.5035eb3d.jpg";